import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import pinia from './store'
import Antd from 'ant-design-vue'
import 'ant-design-vue/dist/reset.css'
import './style.css'
import socketService from '@/utils/websocket';
import ElementPlus from 'element-plus'
import 'element-plus/dist/index.css'
import eventBus from './utils/eventBus'


const app = createApp(App)

app.config.globalProperties.$eventBus = eventBus
app.config.globalProperties.$socket = socketService

app.use(router)
app.use(pinia)
app.use(Antd)
app.use(ElementPlus)
app.mount('#app')

console.log('接口地址：', import.meta.env)